/**
 * Here are all the Backend api calls for our modules
 */
import appApiClient from '../app-api-client'

const pageUriPrefix = "/monitoring/stock/stock-orders-debit/per-warehouse";

export default {

    getIndexData() {
        return appApiClient().get(pageUriPrefix + '/index');
    },

    getReportData(data) {
        return appApiClient().post(pageUriPrefix + '/query', data);
    },

}
